<template>
  <div>
    <top-header v-bind:title="$t('learningTenants')">
      <header-button icon="mdi-plus-box"
                     right
                     slot="right-button"
                     v-bind:label="$t('add')"
                     v-bind:to="{ name: 'learning-tenant-add' }" />
    </top-header>
    <v-container>
      <learningTenant-table-card item-route-name="learning-tenant"
                          v-bind:loading="loading"
                          v-bind:learningTenants="learningTenants" />
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import LearningTenantTableCard from '@/components/learning/LearningTenantTableCard.vue'

  export default {
    components: {
      HeaderButton,
      LearningTenantTableCard,
      TopHeader
    },
    computed: {
      ...mapGetters({
        learningTenants: 'learning/learningTenants'
      })
    },
    async created() {
      this.loading = true

      await this.loadLearningTenants()

      this.loading = false
    },
    data: () => ({
      loading: false
    }),
    methods: {
      ...mapActions({
        loadLearningTenants: 'learning/loadLearningTenants'
      })
    },
    name: 'LearningTenants'
  }
</script>

<i18n>
  {
    "de": {
      "add": "Neu",
      "learningTenants": "Mandanten"
    },
    "en": {
      "add": "Add",
      "learningTenants": "LearningTenants"
    }
  }
</i18n>